import axios from 'axios'
import store from '@/store'
import Router from './../router'

class HttpRequest {
  constructor(baseUrl) {
    this.baseUrl = baseUrl
  }

  getInsideConfig() {
    const config = {
      baseURL: this.baseUrl,
    }
    return config
  }

  interceptors(instance, url) {
    // 请求拦截
    instance.interceptors.request.use(
      (config) => {
        return config
      },
      (error) => {
        return Promise.reject(error)
      },
    )
    // 响应拦截
    instance.interceptors.response.use(
      (res) => {
        // 进行登录错误拦截
        const { data, status } = res
        //   if (status === 200) {
        // 未登录或token过期
        if (data.code === 502) {
          setTimeout(() => {
            Router.push({
              path: '/login',
              query: { redirect: Router.currentRoute.fullPath },
            })
          }, 1000)
        }
        // 对于code错误码 识别 做统一处理
        // let errorMsg = ''
        // switch (data.code) {
        //   case 111:
        //     errorMsg = '1'
        //     break
        //   case 222:
        //     errorMsg = '2'
        //     break
        //   case 333:
        //     errorMsg = '3'
        //     break
        //   default:
        //     errorMsg = data.msg
        // }
        // data.msg = errorMsg
        //   }
        return { data, status }
      },
      (error) => {
        // 对于HTTP状态码错误（如400、500等），如果响应中有data，说明后端返回了具体的错误信息
        if (error.response && error.response.data) {
          // 返回响应数据，让前端能正确处理错误消息
          return Promise.resolve({ 
            data: error.response.data, 
            status: error.response.status 
          })
        }
        // 真正的网络错误或服务器无响应
        const text = '请求失败，服务器异常'
        return Promise.reject(text)
      },
    )
  }

  request(options) {
    const instance = axios.create()
    options = Object.assign(this.getInsideConfig(), options)
    options.headers = {
      ...(options.headers || {}),
      token: store.getters.token,
    }
    this.interceptors(instance, options.url)
    return instance(options)
  }
}
export default HttpRequest
